// extracted by mini-css-extract-plugin
export default {"search":"pg07_search__2LIU7"};